import React, { Component } from 'react';
import { Form } from '@ant-design/compatible';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { Select, Input, Button } from 'antd';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Erase } from '@carbon/icons-react';
import * as assetActions from '../../../core/asset/assetActions';
import DateRangePicker from '../../../components/DateRangePicker';

dayjs.extend(customParseFormat);

const { DB_DATE_FORMAT } = require('../../../core/constants').default;

class CachedVideoFilterForm extends Component {
    componentDidMount() {
        const { actions } = this.props;
        actions.getDivisionListRequest();
        actions.getAssetOptionsRequest();
    }

    submitForm = (e) => {
        e.preventDefault();
        const { onSubmit } = this.props;
        this.props.form.validateFields((err, values) => {
            if (!err) {
                onSubmit(values);
            }
        });
    };

    render() {
        const {
            form, divisions, driverList, assetReg, assetOptions, videoRetentionDays, mapDate
        } = this.props;
        const { getFieldDecorator, getFieldValue } = form;

        let startdate = dayjs().format('YYYY-MM-DD 00:00:00');
        startdate = dayjs(startdate).subtract(videoRetentionDays, 'days');
        let endDate = dayjs().endOf('day');
        let dateFromInitialVal = startdate;
        let assetInfoInitialVal = null;
        if (assetReg) {
            const assetMatches = assetOptions.filter(a => a.reg === assetReg);
            if (assetMatches?.length) assetInfoInitialVal = assetMatches[0]?.name;
        }
        if (mapDate) {
            // If user comes from main map screen then use the map date to show events
            dateFromInitialVal = dayjs(mapDate, DB_DATE_FORMAT);
        }

        return (
            (
                <Form onSubmit={this.submitForm} layout="vertical">
                    <Form.Item label="Reference">
                        {getFieldDecorator('reference', {
                            rules: [
                            ],
                        })(
                            <Input placeholder="Enter Reference" />,
                        )}
                    </Form.Item>
                    <Form.Item label="Asset">
                        {getFieldDecorator('asset_info', {
                            initialValue: assetInfoInitialVal,
                        })(
                            <Select
                                mode="multiple"
                                showSearch
                                allowClear={<Erase size={12} />}
                                filterOption={(txt, obj) => (obj.props.children.toLowerCase().includes(txt.toLowerCase()))}
                                placeholder="Select Asset"
                            >
                                {assetOptions.map((a) => (
                                    <Select.Option key={a.id} value={a.id}>
                                        {a.name === a.reg || a.reg === '' ? a.name : `${a.name} [${a.reg}]`}
                                    </Select.Option>
                                ))}
                            </Select>,
                        )}
                    </Form.Item>
                    <Form.Item label="Driver">
                        {getFieldDecorator('driver', {

                        })(
                            <Select
                                mode="multiple"
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                placeholder="Select Driver"
                                showSearch
                                allowClear={<Erase size={12} />}
                            >
                                {driverList.map((dl) => <Select.Option key={dl.id} value={dl.id}>{dl.name}</Select.Option>)}
                            </Select>,
                        )}
                    </Form.Item>
                    <Form.Item label="Division">
                        {getFieldDecorator('division_id', {
                            rules: [
                            ],
                        })(
                            <Select
                                placeholder="Select Division"
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                mode="multiple"
                                style={{ width: '100%' }}
                                allowClear={<Erase size={12} />}
                                showSearch
                            >
                                {
                                    divisions.map((v, i) => (
                                    /* eslint-disable-next-line react/no-array-index-key */
                                        (<Select.Option key={`${i}`} value={v.id}>{v.name}</Select.Option>)
                                    ))
                                }

                            </Select>,
                        )}
                    </Form.Item>
                    <DateRangePicker
                        getFieldDecorator={getFieldDecorator}
                        getFieldValue={getFieldValue}
                        minDate={dayjs().subtract(videoRetentionDays, 'days')}
                        dateFromInitialValue={dateFromInitialVal}
                        dateToInitialValue={endDate}
                    />
                    <div className="mt-2 text-center">
                        <Button
                            htmlType="submit"
                            type="primary"
                        >
                            Filter
                        </Button>
                    </div>
                </Form>
            )
        );
    }
}

CachedVideoFilterForm.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    actions: PropTypes.object.isRequired,
    divisions: PropTypes.array.isRequired,
    driverList: PropTypes.array.isRequired,
    assetReg: PropTypes.string,
    mapDate: PropTypes.string,
};

const CachedVideoFilter = Form.create({ name: 'event_filter_form' })(CachedVideoFilterForm);

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        event_types: state.asset.event_types,
        divisions: state.asset.divisions,
        driverList: state.driver.driverList,
        assetReg: state.global.videoSearchFilters.assetReg,
        mapDate: state.global.mapDate,
        assetOptions: state.asset.options,
        videoRetentionDays: state.user.userCompany.video_retention_days,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...assetActions,
        }, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(CachedVideoFilter);
